export type RequestStatusKey =
  | 'enviada'
  | 'em_analise'
  | 'aprovada'
  | 'concluida'
  | 'ajuste'
  | 'recusada';

export type StatusTone = 'default' | 'positive' | 'warning' | 'negative';

export interface RequestStatusDef {
  key: RequestStatusKey;
  label: string;
  description: string;
  tone: StatusTone;
}

export const HAPPY_PATH: RequestStatusKey[] = ['enviada', 'em_analise', 'aprovada', 'concluida'];

export const STATUS_DEFS: Record<RequestStatusKey, RequestStatusDef> = {
  enviada: {
    key: 'enviada',
    label: 'Solicitação enviada',
    description: 'Recebemos o seu pedido de acesso à API.',
    tone: 'default',
  },
  em_analise: {
    key: 'em_analise',
    label: 'Em análise',
    description: 'Nossa equipe está conferindo as informações enviadas.',
    tone: 'default',
  },
  aprovada: {
    key: 'aprovada',
    label: 'Aprovada',
    description: 'Está tudo certo com os dados. Estamos preparando o seu acesso.',
    tone: 'positive',
  },
  concluida: {
    key: 'concluida',
    label: 'Acesso liberado',
    description: 'Seu acesso à API foi liberado.',
    tone: 'positive',
  },
  ajuste: {
    key: 'ajuste',
    label: 'Ajuste solicitado',
    description: 'Precisamos que você corrija alguns dados e reenvie a solicitação.',
    tone: 'warning',
  },
  recusada: {
    key: 'recusada',
    label: 'Não aprovada',
    description: 'Sua solicitação não pôde ser aprovada.',
    tone: 'negative',
  },
};

// IDs da tabela api_request_statuses do CRM.
export const STATUS_BY_ID: Record<number, RequestStatusKey> = {
  1: 'enviada',
  2: 'em_analise',
  3: 'ajuste',
  4: 'aprovada',
  5: 'recusada',
  6: 'concluida',
};
